interface CurrentUbkHeader {
  headers: {
    Brandubk?: string | undefined | null;
  };
}

interface DocumentCenterConfig {
  HIGHMARK_API_URL: string;
  HIGHMARK_AXWAY_API_URL: string;
  AMH_CDN_URL: string;
  HIGHMARK_CDN_URL: string;
  enableUMLetters: boolean;
  enableWelcomeGuides: boolean;
  useCurrentRegionUbkHeader: () => Partial<CurrentUbkHeader>;
}

const defaultConfig = {
  HIGHMARK_API_URL: 'https://api-qa.highmark.com',
  HIGHMARK_AXWAY_API_URL: 'https://apiqa.hmhs.com',
  AMH_CDN_URL: 'https://test.cdn.allmyhealth.com',
  HIGHMARK_CDN_URL: 'https://test.cdn.highmark.com',
  enableUMLetters: false,
  enableWelcomeGuides: false,
  useCurrentRegionUbkHeader: () => ({ headers: {} }),
};

let documentCenterConfig: any = defaultConfig;

export const documentCenter = {
  config(config: Partial<DocumentCenterConfig>) {
    if (!config) throw new Error('Document Center: You must provide a config');
    documentCenterConfig = { ...documentCenterConfig, ...config };
  },

  getConfig(): DocumentCenterConfig {
    if (!documentCenterConfig)
      throw new Error('Document Center: Configuration is not defined.');
    return documentCenterConfig;
  },
};
